// extracted by mini-css-extract-plugin
export default {"main":"AdminPanel_main__8VjGa","panel":"AdminPanel_panel__DF1Kj"};